import { render, staticRenderFns } from "./draft_note.vue?vue&type=template&id=361269a8&"
import script from "./draft_note.vue?vue&type=script&lang=js&"
export * from "./draft_note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports